<template>
  <b-modal
    id="complete-mentorship-modal"
    ref="complete-mentorship-modal"
    centered
    size="md"
    :title="$t('Confirm mentorship completion')"
    title-class="font-weight-bolder"
    :ok-title="$t('Yes, i am sure')"
    @ok.prevent="completionConfirmed"
    :cancel-title="$t('Cancel')"
    cancel-variant="outline-primary"
  >
    <b-card-text class="p-2">
      {{ $t('Complete mentorship confirmation message') }}
    </b-card-text>
  </b-modal>
</template>

<script>
import {
  BCardText,
  BModal
} from "bootstrap-vue";
import { useMentorship } from '@mentoring-platform/composables'

export default {
  components: {
    BCardText,
    BModal
  },
  data() {
    return {
      mentorship: null
    }
  },
  methods: {
    show(mentorship) {
      this.mentorship = mentorship
      this.$refs['complete-mentorship-modal'].show()
    },
    completionConfirmed() {
      const payload = {
        id: this.mentorship.id
      }
      this.completeMentorship(payload)
        .then(response => {
          this.$refs['complete-mentorship-modal'].hide()
          this.$bus.$emit('previous-mentorships-list-needs-refresh')
          this.$bus.$emit('current-mentorship-stopped-by-admin')
          this.$root.$bvToast.toast(this.$t('Mentorship successfully completed'), {
            title: this.$t('Confirmation'),
            variant: 'success',
            solid: true,
          })
        })
        .catch(error => {
          this.$root.$bvToast.toast(this.$t('An error occured, please try again later'), {
            title: this.$t('Caution'),
            variant: 'danger',
            solid: true,
          })
        })
    }
  },
  setup() {
    const { completeMentorship } = useMentorship()

    return {
      completeMentorship
    }
  }
};
</script>

<style lang="scss">

</style>
